import { atomWithReset } from "jotai/utils";
import { QUESTION_REPORT_TYPES } from "@/Enums/question_report_types";

const initialValue = {
  title: "",
  tags: [],
  question_type_id: null,
  result_type: QUESTION_REPORT_TYPES.Total,
  inputs: [{ label: "", unit: "", emission_factor_id: null, uuid: -1 }],
  user_id: null,
  teams: [],
  errorBag: "createQuestion",
};

export const createQuestionAtom = atomWithReset(initialValue);
export const editQuestionAtom = atomWithReset(initialValue);
export const reportQuestionsAtom = atomWithReset({});
